import React, { useEffect, useState } from "react";
import axios from "axios";

const CommonDropdownWithAnotherUrl = ({ Api_path, value, onChange, label }) => {
  const [ListData, setListData] = useState([]);

  const fetchData = async() => {
    try {
        const sendRequest = await axios.get(Api_path);
        const response = sendRequest.data.data;
        setListData(response);
        return true;
    } catch (error) {
        return false;
    }
  }
  useEffect(() => {
    fetchData();
  },[])
  return (
    <div>
      <select
        className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-sm focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
        id={label}
        defaultValue={value}
        onChange={(e) => { console.log(e.target.value); onChange(e.target.value)}}
      >
        <option value="">-- Select {label} --</option>
        {ListData.map(({name, _id}, index) => (
          <option key={_id} value={name + '_' + _id}>
            {name}
          </option>
        ))}
      </select>
    </div>
  );
};

export default CommonDropdownWithAnotherUrl;
